 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import OEBPSCOVER from '@/components/OEBPS/cover'
 import OEBPSHALFTITLE from '@/components/OEBPS/halftitle'
 import OEBPSOTHER from '@/components/OEBPS/other'
 import OEBPSTITLE from '@/components/OEBPS/title'
 import OEBPSCOPY from '@/components/OEBPS/copy'
 import OEBPSDEDICATION from '@/components/OEBPS/dedication'
 import OEBPSTOC from '@/components/OEBPS/toc'
 import OEBPSLISTOFMAP from '@/components/OEBPS/listofmap'
 import OEBPSACKNOW from '@/components/OEBPS/acknow'
 import OEBPSANOTE from '@/components/OEBPS/anote'
 import OEBPSINTRO from '@/components/OEBPS/intro'
 import OEBPSCH01 from '@/components/OEBPS/ch01'
 import OEBPSCH02 from '@/components/OEBPS/ch02'
 import OEBPSCH03 from '@/components/OEBPS/ch03'
 import OEBPSCH04 from '@/components/OEBPS/ch04'
 import OEBPSCH05 from '@/components/OEBPS/ch05'
 import OEBPSCH06 from '@/components/OEBPS/ch06'
 import OEBPSCH07 from '@/components/OEBPS/ch07'
 import OEBPSCH08 from '@/components/OEBPS/ch08'
 import OEBPSCH09 from '@/components/OEBPS/ch09'
 import OEBPSCH10 from '@/components/OEBPS/ch10'
 import OEBPSCH11 from '@/components/OEBPS/ch11'
 import OEBPSCH12 from '@/components/OEBPS/ch12'
 import OEBPSCH13 from '@/components/OEBPS/ch13'
 import OEBPSCH14 from '@/components/OEBPS/ch14'
 import OEBPSCH15 from '@/components/OEBPS/ch15'
 import OEBPSCH16 from '@/components/OEBPS/ch16'
 import OEBPSCH17 from '@/components/OEBPS/ch17'
 import OEBPSCH18 from '@/components/OEBPS/ch18'
 import OEBPSCH19 from '@/components/OEBPS/ch19'
 import OEBPSCH20 from '@/components/OEBPS/ch20'
 import OEBPSCH21 from '@/components/OEBPS/ch21'
 import OEBPSCH22 from '@/components/OEBPS/ch22'
 import OEBPSMAP from '@/components/OEBPS/map'
 import OEBPSGLOS from '@/components/OEBPS/glos'
 import OEBPSBIB from '@/components/OEBPS/bib'
 import OEBPSINDEX from '@/components/OEBPS/index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/OEBPS/cover",
 			"name" : "OEBPS/cover",
 			"component" : OEBPSCOVER
 		},
 		{
 			"path" : "/OEBPS/halftitle",
 			"name" : "OEBPS/halftitle",
 			"component" : OEBPSHALFTITLE
 		},
 		{
 			"path" : "/OEBPS/other",
 			"name" : "OEBPS/other",
 			"component" : OEBPSOTHER
 		},
 		{
 			"path" : "/OEBPS/title",
 			"name" : "OEBPS/title",
 			"component" : OEBPSTITLE
 		},
 		{
 			"path" : "/OEBPS/copy",
 			"name" : "OEBPS/copy",
 			"component" : OEBPSCOPY
 		},
 		{
 			"path" : "/OEBPS/dedication",
 			"name" : "OEBPS/dedication",
 			"component" : OEBPSDEDICATION
 		},
 		{
 			"path" : "/OEBPS/toc",
 			"name" : "OEBPS/toc",
 			"component" : OEBPSTOC
 		},
 		{
 			"path" : "/OEBPS/listofmap",
 			"name" : "OEBPS/listofmap",
 			"component" : OEBPSLISTOFMAP
 		},
 		{
 			"path" : "/OEBPS/acknow",
 			"name" : "OEBPS/acknow",
 			"component" : OEBPSACKNOW
 		},
 		{
 			"path" : "/OEBPS/anote",
 			"name" : "OEBPS/anote",
 			"component" : OEBPSANOTE
 		},
 		{
 			"path" : "/OEBPS/intro",
 			"name" : "OEBPS/intro",
 			"component" : OEBPSINTRO
 		},
 		{
 			"path" : "/OEBPS/ch01",
 			"name" : "OEBPS/ch01",
 			"component" : OEBPSCH01
 		},
 		{
 			"path" : "/OEBPS/ch02",
 			"name" : "OEBPS/ch02",
 			"component" : OEBPSCH02
 		},
 		{
 			"path" : "/OEBPS/ch03",
 			"name" : "OEBPS/ch03",
 			"component" : OEBPSCH03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js